import React from 'react';

const ClientPostsJobPostCardSkeleton = () => {
  return (
    <div className="rounded-lg overflow-hidden border border-light-blue animate-pulse">
      {/* Header section */}
      <div className="bg-primary bg-opacity-80 px-6 py-3 flex flex-col md:flex-row items-start md:items-center justify-between gap-2">
        <div className="w-3/5">
          <div className="h-5 bg-white bg-opacity-40 rounded"></div>
        </div>
        <div className="w-1/3 md:w-1/5">
          <div className="h-5 bg-white bg-opacity-40 rounded mt-2"></div>
        </div>
      </div>

      {/* Content section */}
      <div className="bg-white px-6 py-3 flex flex-col md:flex-row justify-between items-start gap-4">
        <div className="flex flex-col gap-4 w-full md:w-2/3">
          {/* Category section */}
          <div>
            <div className="h-4 bg-gray-200 rounded w-20 mb-3"></div>
            <div className="h-10 bg-gray-200 rounded-[20px] w-32"></div>
          </div>

          {/* Skills section */}
          <div>
            <div className="h-4 bg-gray-200 rounded w-16 mb-3"></div>
            <div className="flex flex-wrap md:flex-nowrap gap-2">
              {/* Generate 3 skill placeholders */}
              {[...Array(3)].map((_, idx) => (
                <div 
                  key={idx} 
                  className="h-10 bg-gray-200 rounded-[20px] w-20 md:w-24"
                ></div>
              ))}
            </div>
          </div>
        </div>

        {/* Buttons section */}
        <div className="flex flex-wrap xs:flex-nowrap md:flex-col gap-3 w-full md:w-1/3 justify-center md:items-end md:mt-6 md:mb-3">
          {/* View button placeholder */}
          <div className="h-[35px] bg-gray-200 rounded-[4px] w-full max-w-[150px] min-w-[75px]"></div>
          
          {/* Edit button placeholder */}
          <div className="h-[35px] bg-gray-200 rounded-[4px] w-full max-w-[150px] min-w-[75px]"></div>
          
          {/* Delete button placeholder */}
          <div className="h-[35px] bg-gray-200 rounded-[4px] w-full max-w-[150px] min-w-[75px]"></div>
        </div>
      </div>
    </div>
  );
};

export default ClientPostsJobPostCardSkeleton;